export const getMissingStaffIdentityErrors = (values, t) => {
  if (values.mobile?.trim() || values.email?.trim()) return {};

  const identityError = `${t("email_or_mobile")} ${t("cannot_be_empty")}`;
  return {
    mobile: identityError,
    email: identityError,
  };
};
